import { render } from "./Config.vue?vue&type=template&id=46fefa3b&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"

import "./Config.vue?vue&type=style&index=0&id=46fefa3b&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fefa3b"]])

export default __exports__